import React, { useEffect, useRef } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import styled, { css } from 'styled-components';

export const LicencePlateWrapperInModal = styled.div`
  margin-left: auto;
  > div {
    border-radius: 4px;
  }
`;

export const LicencePlateWrapper = styled.span<{ isBigger?: boolean }>`
  > button {
    padding-left: 1em;
    padding-right: 1em;
    box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.1);
  }

  button {
    ${(props) =>
      props.isBigger &&
      css`
        font-size: 2rem;
      `}
  }
`;

export const LicencePlateInvisibleButtonWrapper = styled.span`
  position: relative;
`;

export const StyledDropdownItem = styled(Dropdown.Item).attrs({ tabIndex: 0, role: 'menuitem' })`
  white-space: pre-wrap;
`;

export const LicencePlateButtonState = styled.span`
  width: 2ch;
  font-size: 0.6em;
  display: inline-block;
  vertical-align: middle;
  line-height: 1.57ch !important;
  text-align: center;
  margin-right: -1em;
  margin-top: -0.3em;
  margin-left: 0.1em;
  text-transform: uppercase;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
`;

const StyledOverlay = styled.div`
  font-size: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const LicencePlateButtonOverlay: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Focus on first focusable child when mounted
    if (containerRef.current) {
      // Find first focusable element
      const focusableElements = containerRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );

      if (focusableElements.length > 0) {
        (focusableElements[0] as HTMLElement).focus();
      }
    }
  }, []);

  return (
    <StyledOverlay ref={containerRef} {...props}>
      {children}
    </StyledOverlay>
  );
};

export const FormControlWithUppercase = styled(FormControl)`
  text-transform: uppercase;
`;
